import { Button } from '@modusign/design-system';
import isEqual from 'lodash/isEqual';

import { useSelectionValues } from '@hooks';

import {
  ResourceModal,
  ResourceModalBody,
  ResourceModalFooter,
  ResourceModalHeader,
} from '@app/components/Modal/ResourceModal';
import { MAX_COUNT_OF_GROUPS_PER_MEMBER } from '@app/features/workspaceManagement/constants';
import { WorkspaceGroup } from '@app/features/workspaceManagement/types';
import WorkspaceGroupSelectList from '@app/features/workspaceManagement/workspaceMemberInvitation/components/WorkspaceGroupSelectList';

interface GrantWorkspaceGroupModalProps {
  initialState: WorkspaceGroup['subjectId'][];
  subtitle: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (value: WorkspaceGroup['subjectId'][]) => void;
}

export default function GrantWorkspaceGroupModal({
  initialState,
  subtitle,
  isOpen,
  onClose,
  onConfirm,
}: GrantWorkspaceGroupModalProps) {
  const workspaceGroupSelection = useSelectionValues<WorkspaceGroup['subjectId']>(initialState);

  return (
    <ResourceModal isOpen={isOpen} maxWidth="sm">
      <ResourceModalHeader resourceName={subtitle} title="그룹" onClose={onClose} />

      <ResourceModalBody>
        <WorkspaceGroupSelectList
          disabled={workspaceGroupSelection.count >= MAX_COUNT_OF_GROUPS_PER_MEMBER}
          selectedGroups={workspaceGroupSelection.selected}
          tooltipContent={`더 이상 그룹을 설정할 수 없습니다. (최대 ${MAX_COUNT_OF_GROUPS_PER_MEMBER})`}
          onToggleGroup={workspaceGroupSelection.toggle}
        />
      </ResourceModalBody>

      <ResourceModalFooter justifyContent="end">
        <Button weight="light" onClick={onClose}>
          취소
        </Button>
        <Button
          disabled={isEqual(initialState, workspaceGroupSelection.selected)}
          ml={3}
          variant="primary"
          weight="light"
          onClick={() => onConfirm(workspaceGroupSelection.selected)}
        >
          적용
        </Button>
      </ResourceModalFooter>
    </ResourceModal>
  );
}
